"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_roadmaps_controller_1 = __importDefault(require("./student-roadmaps.controller"));
var student_roadmaps_html_1 = __importDefault(require("./student-roadmaps.html"));
var StudentRoadmapPanel_directive_1 = __importDefault(require("./StudentRoadmapPanel.directive"));
function getRoadmaps(RoadmapsModel) {
    return RoadmapsModel.get().then(function (response) {
        return response.roadmaps;
    });
}
getRoadmaps.$inject = ["RoadmapsModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.roadmaps", {
        url: "/roadmap",
        controller: student_roadmaps_controller_1.default,
        controllerAs: "vm",
        template: student_roadmaps_html_1.default,
        resolve: {
            roadmaps: getRoadmaps,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.roadmaps", [
    StudentRoadmapPanel_directive_1.default.name,
])
    .config(config)
    .controller("AdminStudentViewRoadmapController", student_roadmaps_controller_1.default);
